/*! BrightFire Stellar - v0.0.1
 * https://www.brightfire.com
 * Copyright (c) 2016; * Licensed GPLv2+ */

( function( $, stellar ) {

    var stellar_mobile_breakpoint;
    var stellar_mobile;

    /**
     * Set up all our vars on window.load
     */
    $(window).load(function () {

        // Find and set our Breakpoint
        stellar_mobile_breakpoint = stellar.getBreakpoint();

        // Check viewport size and set mobile class
        stellar.assignMobile();

        stellar.mobile_video_override();
        stellar.customizerExec();
        stellar.stellarSlider();
        stellar.matchWidgetHeight();
        stellar.setupFixedRows();
        stellar.forceZindex();
        $(".overlap").fadeTo( '500ms', 1 );
    });


    /**
     * Resize Events
     */
    $(window).on( 'resize', function () {

        if( true === stellar.breakpointSwitch() ) {
            stellar.assignMobile();
            stellar.resetFixedRows();
        }

        stellar.mobile_video_override();
        stellar.matchWidgetHeight();
    });

    /**
     * Customizer Initial Setup (and refresh)
     */
    stellar.customizerExec = function() {
        $('div.row').AnimationQueue();
        stellar.stellarSlider();
        stellar.matchWidgetHeight();
        stellar.setupFixedRows();
        stellar.forceZindex();
        stellar.responsiveEmbed();
        $(".overlap").fadeTo( '500ms', 1 );
    }

    /**
     * Gets stellar breakpoint
     * @returns {*|jQuery}
     */
    stellar.getBreakpoint = function() {

        return $('body').attr('data-breakpoint');

    }

    /**
     * Sets JS var and body .mobile class
     */
    stellar.assignMobile = function() {

        if( true === stellar.isMobileViewport() ) {
            stellar_mobile = true;
            $('body').addClass('mobile');
        } else {
            stellar_mobile = false;
            $('body').removeClass('mobile');
        }
    }

    /**
     * Checks viewport width against breakpoint
     * @returns {boolean}
     */
    stellar.isMobileViewport = function() {

        var viewport_width = $(window).width();

        if( viewport_width < stellar_mobile_breakpoint ) {
            return true;
        } else {
            return false;
        }

    }

    /**
     * On resize are we moving past a breakpoint?
     * @returns {boolean}
     */
    stellar.breakpointSwitch = function() {

        // Are we moving past Mobile Breakpoint
        if( ( true === stellar.isMobileViewport() && true === stellar_mobile ) || ( false === stellar.isMobileViewport() && false === stellar_mobile ) ) {
            return false;
        }

        return true;

    }

    /**
     * Set up fixed frows
     */
    stellar.setupFixedRows = function() {

        var body = $('body').not('.wp-admin').not('.mobile'),
            fixed_row_element = body.find('*[data-row-fixed="true"]');

        if (fixed_row_element.length) { // if .row-fixed exists

            var eleHeight = fixed_row_element.actual( 'outerHeight' ),
                menuBg = fixed_row_element.css('background-color'),
                eleTop = fixed_row_element.offset().top,
                adminBar = {};

            if (!$('.row-fixed-placeholder').length) {
                $(fixed_row_element).after('<div class="row-fixed-placeholder" style="height: ' + eleHeight + 'px; background-color: ' + menuBg + ';"></div>');
            }

            var placeholder = $('.row-fixed-placeholder');
                placeholder.hide();

            // Set Initial
            stellar.setRelativePosition( fixed_row_element, placeholder, eleTop );

            // Scroll Listener
            $(document).bind('scroll.fixedRows', function () {

                stellar.setRelativePosition( fixed_row_element, placeholder, eleTop );

            });

            // Resize Listener
            $(window).resize(function () {

                adminBar = stellar.getWpAdminBarSize();

                eleHeight = fixed_row_element.actual( 'outerHeight' ); // If we resize, make sure our height didn't change
                placeholder.css('height', eleHeight + 'px'); // on resize, make sure our placeholder gets height changes

                if (fixed_row_element.hasClass('traveling')) { // if our header is sticky, compensate for possible change in wpHeight
                    fixed_row_element.css('top', adminBar.bottom + 'px');
                }


            });
        }
    }

    stellar.setRelativePosition = function( fixed_row_element, placeholder, eleTop ) {
        var scrollOffset = $(document).scrollTop(),
            adminBar = stellar.getWpAdminBarSize();

        if (scrollOffset > ( eleTop - adminBar.height )) {
            placeholder.show(); // Put in the placeholder so we don't lose vertical alignment
            fixed_row_element.css('position', 'fixed').css('width', '100%').css('top', adminBar.bottom + 'px').css('left', 0).addClass('traveling');
        } else {
            placeholder.hide();
            fixed_row_element.css({'position': '', 'width': '', 'top': '', 'left': ''}).removeClass('traveling');
        }
    }

    stellar.getWpAdminBarSize = function() {

        var bottom, height,
            adminBar = {},
            scrollOffset = $(document).scrollTop();

        if ($('#wpadminbar').length) { // if #wpadminbar exists
            height = $('#wpadminbar').actual( 'outerHeight' );
            bottom = ( $('#wpadminbar').offset().top + height ) - scrollOffset;
        } else {
            bottom = 0;
            height = 0;
        }

        if (bottom <= 0) {
            bottom = 0; // If it's less than 0, make it 0
        }

        if (height <= 0) {
            height = 0; // If it's less than 0, make it 0
        }

        adminBar.bottom = bottom;
        adminBar.height = height;

        return adminBar;

    }

    /**
     * Rebuild fixed rows
     * @returns {boolean}
     */
    stellar.resetFixedRows = function() {

        $('body').find('*[data-row-fixed="true"]').css({'position': '', 'width': '', 'top': '', 'left': ''}).removeClass('traveling');
        $('.row-fixed-placeholder').remove(); // If we are going to call setupFixedRows again, we should remove this
        $(document).unbind('scroll.fixedRows');
        stellar.setupFixedRows();
    }

    stellar.stellarSlider = function() {

        var slider = $('.stellar-slider').not('.slick-initialized');

        $.each(slider, function () {
            $(this).slick({
                autoplay: true,
                arrows: false,
                slidesToShow: 1,
                slidesToScroll: 1
            });
        });
    }

    stellar.matchWidgetHeight = function() {

        // Find all our match elements
        var body = $('body').not('.wp-admin').not('.mobile'); // Don't do this on mobile
        var columns = body.find('.column');

        // Reset all '.matched' element heights
        $('.matched').height('auto').removeClass('matched');

        // Loop Through Each of our columns
        $.each(columns, function () {

            var max_height = 0; // Reset our max-height for each columng
            var match_elements = $(this).find('.match-widget-height'); // All elements to match in this column

            // Loop through all '.match-height' widgets
            $.each(match_elements, function () {
                var ele_height = $(this).actual('outerHeight');

                if (ele_height > max_height) {
                    max_height = ele_height;
                }
            });

            $.each(match_elements, function() {
                var ele_height = $(this).actual('height');
                var ele_outer_height = $(this).actual('outerHeight');

                if (ele_outer_height < max_height) {
                    var adjusted_height = max_height - ele_outer_height;
                    $(this).height(ele_height + adjusted_height);
                }
            });

            match_elements.addClass('matched'); // Set 'matched' class

        });

    }

    // Set row z-indices appropriately for menus, overlap widgets and fixed rows
    stellar.forceZindex = function() {
        var els = $(".overlap, .bfmenu-menubar").parents(".row");

        els = els.add( $('[data-row-fixed="true"]') );

        var i = els.length * 20; // 20 will be the lowest z-index used here.

        els.each(function(){
            $(this).css({"z-index": + i });
            i = i - 20;
        } );
    }

    stellar.mobile_video_override = function() {
        $( 'video.background-video source').each( function() {
            if( stellar.isMobileViewport() ) {
                $(this).attr( 'src', '' );
                $(this).parent('video')[0].pause();
            } else {
                $(this).attr( 'src', $(this).data( 'video-src' ) );
                $(this).parent('video')[0].play();
            }

        });
    }

    stellar.responsiveEmbed = function() {

        // Find iFrames with a youtube.com OR youtu.be in the SRC attribute
        var iframes = $('.widget_bf_cpc iframe[src*="youtube.com"], .widget_bf_cpc iframe[src*="youtu.be"]');

        iframes.each( function() {
            // Remove width and height
            $(this).css('width','100%').removeAttr('height').wrap('<div class="stellar-embed-wrapper aspect-16-9"></div>');

        } );

    }
})(jQuery, window.stellar );